import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import { Button } from '@mui/material';
import { FC } from 'react';
import { useToggleIsCoach } from './model';

interface Props {
  id?: string;
  isCoach?: boolean;
  isCoachUrl: string;
}

export const ToggleIsCoach: FC<Props> = ({ isCoach, isCoachUrl, id }) => {
  const { handleToggleIsCoach, isLoading } = useToggleIsCoach({
    isCoach,
    id,
    isCoachUrl,
  });

  return (
    <Button
      variant="contained"
      color={isCoach ? 'success' : 'error'}
      startIcon={isCoach ? <CheckCircleIcon /> : <UnpublishedIcon />}
      size="small"
      onClick={handleToggleIsCoach}
      disabled={isLoading}
    >
      Коуч
    </Button>
  );
};
